// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"1322e7e5da575e5131b4","655":"a1cc9995cfce75302f5f"}[chunkId] + ".js";
};